<script>
  import PortfolioListTabs from './Tabs.svelte';
  import PortfolioListYears from './Years.svelte';
  import PortfolioListTable from './Table.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let tabs = [];
  export let items = [];
  export let years = [];
  let grow = false;

  // Fix tabs years type error
  tabs.map((tab) => {
    tab.years =
      typeof tab.years == 'object' ? Object.values(tab.years) : tab.years;
    return tab;
  });

  // Filter for project table
  let filter = {
    tab: 'business',
    year: 2023,
  };

  // Years to display
  let activeYears;
  // Projects to display
  let filteredProjects;

  // Create filtered projects
  function createFilteredProjects() {
    filteredProjects = items.filter((item) => {
      return item.year === filter.year && item.tab === filter.tab;
    });
  }

  // Handle tab change
  function handleTabChange(event) {
    filter.tab = event.detail.id;

    // Fix type error
    years = typeof years == 'object' ? (years = Object.values(years)) : years;

    activeYears = years
      .filter((year) => {
        return tabs
          .find((tab) => {
            return tab.id === filter.tab;
          })
          .years.includes(year.id);
      })
      .sort(function (a, b) {
        return b.id - a.id;
      });

    filter.year = activeYears[0].id;

    createFilteredProjects();
  }

  // Set initial data
  handleTabChange({
    detail: {
      id: filter.tab,
    },
  });

  // console.log(filter);
  // console.log(activeYears);
</script>

<section>
  <div
    class="container"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <PortfolioListTabs {tabs} active={filter.tab} on:change={handleTabChange} />

    <PortfolioListYears
      years={activeYears}
      bind:active={filter.year}
      on:change={createFilteredProjects}
    />

    <PortfolioListTable projects={filteredProjects} />
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .container {
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }
  }
</style>
